import { inject, Injectable } from "@angular/core";
import { ConfigApiService } from "./config-api.service";
import { catchError, EMPTY, Observable, of, tap } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { FeeValueConfig } from "@models/configs/fee-value-config";

@Injectable({
  providedIn: 'root'
})
export class ConfigSettingsService{
  #configService = inject(ConfigApiService);
  #toastr = inject(ToastrService);

  private paymentUrl: string | null = null;
  private feeValueConfig: FeeValueConfig | null = null;

  getPaymentUrl(): Observable<string> {
    if (this.paymentUrl) {
      return of(this.paymentUrl);
    }

    return this.#configService.getPaymentUrl().pipe(
      tap((url) => {
        this.paymentUrl = url;
      }),
      catchError(() => {
        this.#toastr.error('Failed to load payment URL');
        return EMPTY;
      })
    );
  }

  getFeeConfig(): Observable<FeeValueConfig> {
    if (this.feeValueConfig) {
      return of(this.feeValueConfig);
    }

    return this.#configService.getFeeValueConfig().pipe(
      tap((url) => {
        this.feeValueConfig = url;
      }),
      catchError(() => {
        this.#toastr.error('Failed to load fee value config');
        return EMPTY;
      })
    );
  }
}
